import LidoStake from '~/components/StakingProduct/Lido/Stake'
import i18n from '~/i18n'
import { HOST } from '~/constants/host'

export const getStaticProps = async () => {
  const t = i18n.t

  return {
    props: {
      openGraphData: [
        {
          property: 'og:url',
          content: `${HOST}/staking/lido/stake`,
          key: 'ogurl',
        },
        {
          property: 'og:title',
          content: t('meta_staking_title'),
          key: 'ogtitle',
        },
        {
          property: 'og:description',
          content: t('meta_staking_description'),
          key: 'ogdesc',
        },
      ],
    },
  }
}

export default LidoStake
